import './bootstrap';
import KTComponents from "../metronic/core/index";
import KTLayout from "../metronic/app/layouts/demo1.js";
import app, { showToast } from './vue/backoffice';
import $ from "jquery";

// Mount Vue app
app.mount('#back-office-app');

// Wait for DOM and Metronic to be ready
document.addEventListener('DOMContentLoaded', () => {
    // Make toast available globally if needed
    window.showToast = showToast;

    KTComponents.init();
    KTLayout.init();
});

//Auto Submit for the Filter Form when any input change
$(document).ready(function () {
    const $form = $('.filter-form');
    if ($form.length === 0) return;

    let debounceTimer = null;
    const submitForm = () => {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
            debounceTimer = null;
        }
        $form.trigger('submit');
    };

    // Immediate submit on change for most controls
    $form.on('change', 'input, select, textarea', function () {
        submitForm();
    });

    // Debounced submit while typing for text-like inputs
    $form.on('input', 'input[type="text"], input[type="search"], input[type="number"], input[type="date"], input[type="time"], textarea', function () {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(submitForm, 500);
    });

    // Explicitly handle select2 events (select and clear)
    $form.on('select2:select select2:clear', 'select[data-toggle="select2"], select[data-toggle="select2-multiple"]', function () {
        submitForm();
    });
});

// Form Submit Button Loading
$('form').on('submit', function(e) {
    e.preventDefault();
    var form = this;
    const submitButton = $(document.activeElement);

    if (submitButton.hasClass('submit-form-btn')) {
        // Show loading for submit button
        $('button.submit-form-btn').attr('disabled', true);
        $('button.submit-form-btn > .indicator-label').addClass('hidden');
        $('button.submit-form-btn > .indicator-progress').removeClass('hidden');
    } else if (submitButton.hasClass('submit-draft-form-btn')) {
        // Add draft input if enabled
        let draftInput = $(form).find('input[name="is_draft"]');
        if (draftInput.length === 0) {
            $(form).append('<input type="hidden" name="is_draft" value="1">');
        } else {
            draftInput.val('1');
        }

        // Show loading for draft button
        $('button.submit-draft-form-btn').attr('disabled', true);
        $('button.submit-draft-form-btn > .indicator-label').addClass('hidden');
        $('button.submit-draft-form-btn > .indicator-progress').removeClass('hidden');
    }

    form.submit();
});

// DismissAlert Function
window.dismissAlert = function (alertId) {
    const alert = document.getElementById(alertId);
    if (alert) {
        alert.classList.add('hidden');
    }
}

// ShowMoreFilter Function
window.toggleFilter = function () {
    const section = document.getElementById('filter-show-more');
    const icon = document.getElementById('filter-show-more-icon');
    const isHidden = section.classList.contains('hidden');

    if (isHidden) {
        section.classList.remove('hidden');
        icon.classList.add('rotate-180');
    } else {
        section.classList.add('hidden');
        icon.classList.remove('rotate-180');
    }
}
